module.exports = __webpack_public_path__ + "static/img/0010-A-01.8859200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audioimg/0010-A-01.jpg
// module id = z63z
// module chunks = 0